import { render } from "./commentSecond.vue?vue&type=template&id=835dad50&scoped=true&ts=true"
import script from "./commentSecond.vue?vue&type=script&lang=ts"
export * from "./commentSecond.vue?vue&type=script&lang=ts"

import "./commentSecond.vue?vue&type=style&index=0&id=835dad50&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/www.soyoung.com-vue3-pc-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835dad50"]])

export default __exports__